import { render, staticRenderFns } from "./Protection.vue?vue&type=template&id=10db93fa"
import script from "./Protection.vue?vue&type=script&lang=js"
export * from "./Protection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10db93fa')) {
      api.createRecord('10db93fa', component.options)
    } else {
      api.reload('10db93fa', component.options)
    }
    module.hot.accept("./Protection.vue?vue&type=template&id=10db93fa", function () {
      api.rerender('10db93fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/detail-card/Protection.vue"
export default component.exports